import type { TBlueObj } from "@app/types/insider";

export type TApp = {
  thisPath: string;
  version: string;
  absolutestart: string | Date;
  idb: string;
};

// let pName = `app.${window.location.host.substring(0, 9)}`;
// if (process.env.REACT_APP_MODE === 'DELPHI') {
//   const appIsPersonalKarma = ['true', 'True', true].includes(
//     window?.['__appIsPersonalKarma'],
//   );
//   const persistorName = window?.['__persistorName'] || 'default';
//   pName = `${appIsPersonalKarma ? 'P' : 'J'}${persistorName.substring(0, 10)}`;
// }
// pName = (pName || '').replaceAll(' ', '').trim();

export const idb_app = {
  name: "app",
};

export const appRepo: TBlueObj<TApp> = {
  ...idb_app,
  initialState: {
    thisPath: "",
    version: "",
    absolutestart: null,
    idb: "",
  },
  starfx: true,
  idb: false,
  bootPriority: 3,
};

export type TWhoami = {
  UserName: string;
  Nume: string;
  Prenume: string;
  PrenumeNume: string;
  AmaId: number;
  DreptSuprem: boolean;
  DreptFacturare: boolean;
  AppIsPersonalKarma: boolean;
  LOGINCTX: string;
  wai_host: string;
  wai_path: string;
  wai_database: string;
};

export const idb_whoami = {
  name: "whoami",
};
export const whoamiRepo: TBlueObj<TWhoami> = {
  name: "whoami",
  initialState: {
    UserName: "",
    Nume: "",
    Prenume: "",
    PrenumeNume: "",
    AmaId: 0,
    DreptSuprem: false,
    DreptFacturare: false,
    AppIsPersonalKarma: false,
    LOGINCTX: "",
    wai_host: "",
    wai_path: "",
    wai_database: "",
  } as TWhoami,
  // apiUrl: '/assets/whoami' // not on object //
  starfx: true,
  idb: true,
  bootPriority: 3,
};
